import React from 'react';
import { Permissions } from 'data/user/constants';
import RestrictedContent from 'app/components/RestrictedContent';
import Button from 'components/Button';
import { withRouter } from 'react-router-dom';
import css from '../../../app/Property/Detail/style.scss';

const AnalysisButton = ({ onRef, isLoading, location, propertyId }) => {
  let url;

  const campaignMatch = location.pathname.match(/\/campaign\/(\d+)\/dialer\/(\d+)/);

  const groupMatch = location.pathname.match(/\/property\/group\/(\d+)\/(\d+)/);

  if (campaignMatch) {
    const [, campaignId, dialerCampaignId] = campaignMatch;

    url = `/campaign/${campaignId}/dialer/${dialerCampaignId}/property-details/${propertyId}/analysis/purchase`;
  } else if (groupMatch) {
    const [, groupId] = groupMatch;

    url = `/property/group/${groupId}/${propertyId}/analysis/purchase`;
  } else {
    url = `/search/${propertyId}/analysis/purchase`;
  }

  return (
    <RestrictedContent permission={Permissions.analysisView}>
      <Button className={css.AnalysisButton} onRef={onRef} loading={isLoading} url={url}>
        Analysis
      </Button>
    </RestrictedContent>
  );
};

export default withRouter(AnalysisButton);